// ResponsiveGestionVente.jsx → src/gestion-vente/
import React from "react";
import GestionVente from "./GestionVente";
import VentesMobile from "../mobile/ventes/VentesMobile";
import useIsMobile from "../hooks/useIsMobile";
import { useLocation } from "react-router-dom";

export default function ResponsiveGestionVente(props) {
  const isMobile = useIsMobile();
  const location = useLocation();
  const isRestoringManualSale =
    location.state?.stockReplenishmentReturn?.source_type === "sale" &&
    Boolean(location.state.stockReplenishmentReturn.sales_draft_id);

  return isMobile && !isRestoringManualSale ? (
    <VentesMobile {...props} />
  ) : (
    <GestionVente {...props} />
  );
}
